import https from "../utils/http";
//
/**
 *  公共接口
 */

/** 获取区域数据 省市区三级联动 */
export function getRegion(params) {
  return https.get(`common/region`, params);
}
/** 获取导航菜单 */
export function getNavBar(params) {
  return https.get(`common/nav`, params);
}

/** 获取右侧悬浮框_右上角角标数量+搜索热词 */
export function getRightNumAndHotWords(params) {
  return https.get(`/index/right_count`, params);
}

/** 获取公共为你推荐*/
export function getRecommend(params) {
  return https.get(`/index/to_you`, params);
}
// /** 获取器械专区热销为你推荐*/
// export function getQxRecommend(params) {
//   return https.get(`/instrument/hot`, params);
// }
// /** 获取跑马灯器械专区为你推荐*/
// export function getQxBuyRecommend(params) {
//   return https.get(`/instrument/buySwapList`, params);
// }
// /** 获取器械专区轮播图为你推荐*/
// export function getQxLbRecommend(params) {
//   return https.get(`/instrument/banner`, params);
// }
/** 获取footer*/
export function getFooter(params) {
  return https.get(`/index/footer_help`, params);
}

/*
 * 发送验证码
 * */
export function sendVerify(params) {
  return https.post(`common/sendVerify`, params);
}

/** 获取会员等级 */
export function getRankList(params) {
  return https.get(`/common/rank`, params);
}

/** 获取注册用户信息查重 */
export function getUserCheck(params) {
  return https.post(`/common/checkData`, params);
}

// 修改收货人电话 请求
export function updateAddress(params) {
  return https.post(`/userInfo/updateAddress`, params);
}

/** 获取直播开关 */
export function getliveOF(params) {
  return https.get(`/common/globalzhibo`, params);
}


// WEBPACK FOOTER //
// ./src/api/commonApi.js